<template>
    <div @click="$emit('CloseView')" class="w-full h-[150%] fixed top-0 left-0 bg-[#00000063] z-30 backdrop-blur-[2px]">
    </div>
    <div class="flex fixed justify-center top-[20%] bottom-[20%]  left-[10%] right-[10%] items-center  z-40">
        <div class="flex flex-col justify-center  z-40 bg-white w-[1000px] text-lg rounded-lg border-[2px] border-[#006A00] relative">
            <div v-if="loading" class="absolute bg-[#00000042] w-full h-full flex justify-center items-center z-0" >
                <span class="loader z-50"></span>
            </div>
            <div class="pafcpic_header bg-[#016B00] py-3 px-6">
                <p class="text-[#ffffff] text-md font-semibold">{{ fname +" "+ mname +" " + lname }} </p>
                
            </div>
            <div class="">
                    <img src="">
            </div>
            <div class="flex  bg-[#016B00] px-5 pt-2">
                <button :class="{active: Active == items.Buttonname}" v-for="(items, index) in Employee" :key="index" class="text-sm font-semibold font-sm text-[#ffffff] hover:text-[#b8b8b8] py-3 px-4 rounded-t-lg" @click="Active = items.Buttonname">{{ items.title }}</button>
            </div>
            <div class="Personal-Information px-5 py-4 h-[400px] overflow-auto" v-if="Active === 'Button1'">
                <p class=" pb-3 text-md font-semibold text-[#016B00]">PERSONAL INFORMATION</p>
             
                    <div class="grid grid-cols-3 gap-3 ">
                        <div class="w-full">
                            <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">First Name*</label>
                            <input type="text"  class=" border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="Firstname"             v-model="fname">
                        </div>
                        <div class="w-full">
                            <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Middle Name</label>
                            <input type="text"  class=" border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="Middlename"            v-model="mname">
                        </div>
                        <div class="w-full">
                            <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Last Name*</label>
                            <input type="text"  class=" border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="LastName"              v-model="lname">
                        </div>

                        <div class="w-full">
                            <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Birthdate*</label>
                            <input type="date"  class=" border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="Birthday"              v-model="bdate">
                        </div>

                        <div class="w-full col-span-2">
                            <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Birthplace*</label>
                            <input type="text"  class=" border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="Birthplace" v-model="birthplace">
                        </div>

                        <div class="w-full">
                            <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Gender*</label>
                            <select v-model="gender" class=" border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none">
                                <option value="" selected disabled>Select Gender</option>
                                <option value="MALE">MALE</option>
                                <option value="FEMALE">FEMALE</option>    
                            </select>
                        </div>

                        <div class="w-full">
                            <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Civil Status*</label>
                            <select v-model="civil" class=" border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" >
                                <option value="" selected disabled>Select Civil Status</option>
                                <option value="MARRIED">MARRIED</option>
                                <option value="SINGLE">SINGLE</option>
                                <option value="WIDOWED">WIDOWED</option>
                                <option value="SEPERATED">SEPERATED</option>
                                <option value="DIVORCED">DIVORCED</option>        
                            </select>
                        </div>
                       
                        <div class="w-full">
                            <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Nationality*</label>
                            <input type="text"  class=" border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="Nationality"           v-model="nationality">
                        </div>
                       
                        <div class="w-full">
                            <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Religion*</label>
                            <select class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" v-model="religion">
                                <option value="" disabled>Select Religon</option>
                                <option v-for="(data,index) in $store.state.religion" :key="index" :value="data.name">{{ data.name }}</option>
                            </select>
                            <!-- <input type="text"  class=" border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="Religon"               v-model="religion"> -->
                       </div>
                    </div>    
            </div>




            <div class="Personal-Information px-5 py-4 h-[400px] overflow-auto"  v-if="Active === 'Button2'">
                <p class=" pb-3 text-md font-semibold text-[#016B00]">EMPLOYMENT INFORMATION</p>
                    <div class="grid grid-cols-4 gap-3 ">
                        <div class="w-full col-span-2">
                            <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Office/Division*</label>
                            <select class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" v-model="divisionData" @change="changeDepartment">
                                <option selected disabled value="">Select Office/Division</option>
                                <option v-for="(division, index) in division" :key="index" :value="division.division_code">{{ division.division_description }}</option>
                            </select>
                        </div>
                        <div class="w-full col-span-2">
                            <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Department</label>
                            <select class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" v-model="departmentID" @change="changeSection">
                                <option selected value="">N/A</option>
                                <option v-for="(department, index) in Department" :key="index" :value="department.department_code">{{ department.department }}</option>
                            </select>
                        </div>
                        <div class="w-full col-span-2">
                            <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Section</label>
                            <select  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" v-model="SectionData" @change="getpos">
                                <option selected value="">N/A</option>
                                <option v-for="(section, index) in Section" :key="index" :value="section.section_code">{{ section.section }}</option>
                            </select>
                        </div>

                        <div class="w-full col-span-2">
                            <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Position*</label>
                            <select  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" v-model="PositionData">
                                <option selected value="">N/A</option>
            
                                <option v-for="(position, index) in filterPosition" :key="index" :value="position.position_key">{{ position.position_desc }}{{ position.rank }}</option>
                            </select>
                        </div>

                        <div class="grid grid-cols-3 gap-3 col-span-4 ">
                            <div class="w-full col-span-1">
                                <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Salary Grade*</label>
                                <input type="text"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="00" v-model="salaryGrade">
                            </div>
    
                            <div class="w-full col-span-1">
                                <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Employment Status*</label>
                                <select class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" v-model="employmentStatus">
                                <option value="" disabled>Select Employment Status</option>
                                <option value="PROBATIONARY">PROBATIONARY</option>
                                <option value="REGULAR">REGULAR</option>
                                <option value="PROJECT HIRED">PROJECT HIRED</option>
                                </select>
                            </div>
    
                            <div class="w-full col-span-1">
                                <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Date Hired*</label>
                                <input type="date"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" v-model="dateHired">
                            </div>
                        </div>
                        
                        <div class="w-full col-span-2">
                            <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">SSS NO.*</label>
                            <input type="text"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="XX-XXXXXXX-X" v-model="sss" @input="formatSssNumber">
                        </div>
                       
                        <div class="w-full col-span-2">
                            <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">PAG-IBIG NO.*</label>
                            <input type="text"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="XXXXXXXXXXXX" v-model="pagibig" @input="formatPagibigNumber">
                       </div>
                       <div class="w-full col-span-2">
                        <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">PHILHEALTH NO.*</label>
                        <input type="text"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="XX-XXXXXXXXX-X" v-model="philhealth"  @input="fortmatPhilhealth" >
                    </div>
                   
                    <div class="w-full col-span-2">
                        <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">TIN NO.*</label>
                        <input type="text"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="XXX-XXX-XXX" v-model="tin" @input="formatTinNumber">
                   </div>
                       
                        
                    </div>
                     <p class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" v-if="succes">PERSONAL INFORMATION UPDATED</p>

            </div>


            <div class="Personal-Information px-5 py-4 h-[400px] overflow-auto" v-if="Active === 'Button3'">
                <p class=" pb-3 text-md font-semibold text-[#016B00]">CONTACT INFORMATION</p>
                    <div class="grid grid-cols-3 gap-3 ">
                        <div class="grid grid-cols-6 gap-3 col-span-3">
                            <div class="w-full col-span-2">
 
                                <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Home Address*</label>
                                <input type="text"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="House no., block, village, street" v-model="HomeAddress">
                            </div>
                            <div class="w-full col-span-1">
                                <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Home Province*</label>
                                <!-- <select class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none">
                                    <option value="000000">Metro Manila</option>
                                    <option v-for="(data, index) in $store.state.region" :key="index" :value="data">{{  data.name }}</option>
                                    
                                </select> -->
                                <input type="text"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="Metro Manila" v-model="HomeProvince">
                            </div>
                            <div class="w-full col-span-1">
                                <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Home City*</label>
                                <input type="text"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="Taguig City" v-model="HomeCity">
                            </div>
                            <div class="w-full col-span-1">
                                <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Home Barangay*</label>
                                <input type="text"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="Pinagsama" v-model="HomeBarangay">
                            </div>
                            <div class="w-full col-span-1">
                                <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Home Zip code*</label>
                                <input type="text"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="1232" v-model="HomeZipcode">
                            </div>
                        </div>
                        <div class="grid grid-cols-6 gap-3 col-span-3">
                            <div class="w-full col-span-2">
                                <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Present Address*</label>
                                <input type="text"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="House no., block, village, street" v-model="presentAddress">
                            </div>
                            <div class="w-full col-span-1">
                                <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Present Province*</label>
                                <input type="text"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="Metro Manila" v-model="presentProvince">
                            </div>
                            <div class="w-full col-span-1">
                                <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Present City*</label>
                                <input type="text"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="Taguig City" v-model="presentCity">
                            </div>
                            <div class="w-full col-span-1">
                                <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Present Barangay*</label>
                                <input type="text"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="Pinagsama" v-model="presentBarangay">
                            </div>
                            <div class="w-full col-span-1">
                                <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Present Zip code*</label>
                                <input type="text"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="1232" v-model="presentZipcode">
                            </div>
                        </div>
                        
                        

                        <div class="grid grid-cols-3 gap-3 col-span-3 ">
                            <div class="w-full col-span-1">
                                <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Mobile Number*</label>
                                <input type="tel"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="+63" maxlength="13" v-model="mobileNumber" @input="mobileVerification">
                            </div>
    
                            <div class="w-full col-span-1">
                                <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Phone Number (Landline)</label>
                                <input type="tel"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none"  maxlength="9" placeholder="5512476" v-model="landline">
                            </div>
    
                            <div class="w-full col-span-1">
                                <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Email *</label>
                                <input type="text"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="pafcpic@gmail.com" v-model="email" @input="isValidEmail">
                            </div>
                        </div>
                        
                       
                        <div class="w-full col-span-1">
                            <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Emergency Contact Information *</label>
                            <input type="text"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="Name" v-model="emergencyContactInformation">
                        </div>
                       
                        <div class="w-full col-span-1">
                            <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Relationship *</label>
                            <input type="text"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="Father" v-model="relationship">
                       </div>
                       <div class="w-full col-span-1">
                        <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Emergency Contact Number *</label>
                        <input type="text"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="+63" maxlength="13" v-model="emergengcyContactNumber" @input="emergencymobileVerification">
                        </div>
                    </div>


                  
            </div>



            <div class="Personal-Information px-5 py-4 h-[400px] overflow-auto" v-if="Active === 'Button4'">
                <p class=" pb-3 text-md font-semibold text-[#016B00]">SPOUSE INFORMATION</p>
                    <div class="grid grid-cols-3 gap-3 ">
                        <div class="grid grid-cols-3 gap-4 col-span-3">
                            <div class="w-full col-span-1">
                                <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Spouse First name</label>
                                <input type="text"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="FirstName" v-model="SpouseFirstname">
                            </div>
                            <div class="w-full col-span-1">
                                <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Spouse Middle name</label>
                                <input type="text"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="MiddleName" v-model="SpouseMiddlename">
                            </div>
                            <div class="w-full col-span-1">
                                <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Spouse Last name</label>
                                <input type="text"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="LastName"  v-model="SpouseLastname">
                            </div>

                        </div>
                        <div class="w-full col-span-1">
                            <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Spouse Birthdate</label>
                            <input type="date"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none"    v-model="SpouseBirthdate">
                        </div>
                        <div class="w-full col-span-1">
                            <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Spouse Birthplace</label>
                            <input type="text"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="Birth Place" v-model="SpouseBirthplace"            >
                        </div>

                        <div class="w-full col-span-1">
                            <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Date of Marriage</label>
                            <input type="date"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="MM-DD-YYYY" v-model="SpouseDateofMarriage">
                        </div>

                        
                       
                        <div class="w-full col-span-2">
                            <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Place of Marriage</label>
                            <input type="text"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="MAKATI CITY" v-model="SpousePlaceofMarriage">
                        </div>
                       
                        <div class="w-full col-span-1">
                            <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Spouse Contact No.</label>
                            <input type="text"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="09XXXXXXXXX" v-model="SpouseContactNo">
                       </div>
                       <div class="w-full col-span-2">
                            <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Spouse Address</label>
                            <input type="text"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="Enter Address" v-model="SpouseAddress">
                       </div>


                       <div class="w-full col-span-1">
                            <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Spouse Occupation</label>
                            <input type="text"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="Enter Occupation" v-model="SpouseOccupation">
                       </div>
                   
                        <div class="w-full col-span-1">
                            <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Name of Employer</label>
                            <input type="text"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="Enter Name of Employer" v-model="SpouseEmployer">
                        </div>
                        <div class="w-full col-span-1">
                            <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Bussiness Contact No.</label>
                            <input type="text"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="Enter Bussiness Contact No." v-model="SpouseEmployerContact">
                        </div>

                        <div class="w-full col-span-1">
                            <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Bussiness Address</label>
                            <input type="text"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="Enter Bussiness Address" v-model="SpouseEmployerBussinessAddress">
                        </div>
                    </div>      
            </div>
            <div class="Personal-Information px-5 py-4 h-[400px] overflow-auto" v-if="Active === 'Button5'">
                <p class=" pb-3 text-md font-semibold text-[#016B00]">PARENTS INFORMATION</p>
                    <div class="grid grid-cols-5 gap-3">
                            <div class="grid grid-cols-3 gap-3 col-span-5">
                                <div class="col-span-1">
                                    <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Father's First Name</label>
                                    <input type="text"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="Firstname" v-model="FAfirstname">
                                </div>
                                <div class="col-span-1">
                                    <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Father's Middle Name</label>
                                    <input type="text"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="Middlename" v-model="FAmiddlename">
                                </div>
                                <div class="col-span-1">
                                    <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Father's Last Name</label>
                                    <input type="text"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="Lastname" v-model="FAlastname">
                                </div>
                            </div>
                            <div class="grid grid-cols-2 gap-3 col-span-5">
                                <div class="col-span-1">
                                    <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Father's Contact Number</label>
                                    <input type="text"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="09XXXXXXXXXX" v-model="FAcontactno">
                                </div>
                                <div class="col-span-1">
                                    <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Father's Birthdate</label>
                                    <input type="date"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" v-model="FAbirthdate">
                                </div>
                            </div>
                    </div>
                    <div class="grid grid-cols-5 gap-3">
                        <div class="grid grid-cols-3 gap-3 col-span-5">
                            <div class="col-span-1">
                                <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Mother's First Name</label>
                                <input type="text"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="Firstname" v-model="MOfirstname">
                            </div>
                            <div class="col-span-1">
                                <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Mother's Middle Name</label>
                                <input type="text"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="Middlename" v-model="MOmiddlename">
                            </div>
                            <div class="col-span-1">
                                <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Mother's Last Name</label>
                                <input type="text"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="Lastname" v-model="MOlastname"> 
                            </div>
                        </div>
                        <div class="grid grid-cols-2 gap-3 col-span-5">
                            <div class="col-span-1">
                                <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Mother's Contact Number</label>
                                <input type="text"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="09XXXXXXXXXX" v-model="MOcontactno">
                            </div>
                            <div class="col-span-1">
                                <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Mother's Birthdate</label>
                                <input type="date"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" v-model="MObirthdate">
                            </div>
                        </div>
                </div>   
            </div>

            <div class="Personal-Information px-5 py-4 h-[400px] overflow-auto" v-if="Active === 'Button6'">
                <div class="flex items-center pb-3 gap-5">
                    <p class=" text-md font-semibold text-[#016B00]">DEPENDENT INFORMATION</p>
                    <button class="text-xs bg-[#016B00] py-2 px-4 rounded-lg text-white" @click="$emit('addDependent')">+ Add Dependent</button>
                </div>
                <table class="w-full  ">
                    
                    <tr class="">
                        <th  class="text-white text-xs font-medium">Last Name</th>
                        <th  class="text-white text-xs font-medium">First Name</th>
                        <th  class="text-white text-xs font-medium">Middle Name</th>
                        <th  class="text-white text-xs font-medium">Relation</th>
                        <th  class="text-white text-xs font-medium">Contact No.</th>
                        <th  class="text-white text-xs font-medium">Action</th>
                    </tr>
                    <tbody class="h-[20px]">
                        <tr class="bg-[#ffffff] text-[12px] py-" v-for="(data,index) in dependentInfo" :key="index">
                                <td>{{ data.lname}}</td>
                                <td>{{ data.fname    }}</td>
                                <td>{{ data.mname}}</td>
                                <td>{{ data.relation    }}</td>
                                <td>{{ data.contact_no }}</td>
                            <td><DeleteButton @click="$emit('removeDependent',data.id)"/></td>
                        </tr>
                    </tbody>
                </table>
             
                
            </div>

            
            <div class="Personal-Information px-5 py-4 h-[400px] overflow-auto" v-if="Active === 'Button7'">
                <p class=" pb-3 text-md font-semibold text-[#016B00]">ACCOUNT INFORMATION</p>
                <div class="w-[130px] h-[130px] ">
                    <div v-if="loadingprofile" class="absolute object-cover bg-[#00000042]  w-[117px] h-[120px] rounded-lg	   flex justify-center items-center z-10" >
                        <span class="loader z-50"></span>
                    </div>
                    <img :src="url"  class=" object-cover w-full bg-[#463a3a] h-[130px] rounded-2xl " >
                </div>
                <div class="flex gap-10">
                    <div class="w-full col-span-1">
                        <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Username</label>
                        <input type="text"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="Enter Username"   v-model="username">
                    </div>
                    <div class="w-full col-span-1">
                        <label class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Password</label>
                        <!-- <input type="text"  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="Enter Password"  v-model="password"> -->
                        <div class="relative">
                            <input  class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" :type="ShowPassword" placeholder="Enter Password" v-model="password">
                            <button class="absolute right-5 top-2.5 outline-none select-none" @click="Showpass">
                                <div class="flex items-center">
                                    <div v-if="ShowPassword == 'password'">
                                        <Closepassword/>
                                    </div>
                                    <div v-else>
                                        <Showpassword/>
                                    </div>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>






        <div class="pafcpic_footer flex gap-4 justify-end px-5 py-3 border-[#00800048] border-t font-medium">
            <button class="py-2 px-11 text-sm bg-[#016B00] rounded-md text-[#ffff]" @click="UpdatePersonalInformation">Save</button>
            <button class="text-sm text-[#6A6A6A] bg-[#D9D9D9] py-1.5 px-7 rounded-md" @click="$emit('CloseView')" >Close</button>
        </div>
    </div>
    </div>
    <div v-if="updatedInfo">
        <Prompt @CloseSignatory="updatedInfo =  false" type="UPDATEINFO"/>
    </div>
   

</template>

<script>
import Services from "../../../services/admin";
import Prompt from '../Prompt/RequestPromt.vue'
import { defineComponent } from "vue";
import DeleteButton from "../Button/DeleteControl.vue"
import Showpassword from "../../icons/ShowPassword.vue"
import Closepassword from "../../icons/ClosePassword.vue"

export default defineComponent({
components: {
    DeleteButton,
    Prompt,
    Showpassword,
    Closepassword,
   
},
data() {
    return {
            mobileNumber:       null,
            ShowPassword:    'password',
           updatedInfo:           false,
            loading:             false,   
            Active:          'Button1',
            emp_key:              null,
            GetName:                '',
            fname:                  '',
            mname:                  '',
            lname:                  '',
            bdate:                  '',
            birthplace:             null,
            gender:                 '',
            civil:                  '',
            nationality:            null,
            religion:               null,
            birthday:               '',
            success:             false,
            divisionData:           '',
            division:               '',
            departmentID:           '',
            Department:             '',
            SectionData:            '',
            Section:                '',
            PositionData:           '',
            position:               '',
            
            //EMPLOYMENT INFORMATION
            salaryGrade:                 '',
            dateHired:                   '',
            employmentStatus:            '',
            sss:                         '',
            philhealth:                  '',
            tin:                         '',
            pagibig:                     '',
            //CONTACT INFORMATION
            landline:                    '',
            email:                       '',
            emergencyContactInformation: '',
            relationship:                '',
            emergengcyContactNumber:     '',

            //HOME ADDRESS
            GetHomeAddres:'',
            homeAddress:        '',
            homeProvince:       '',
            homeCity:           '',
            homeBarangay:       '',
            homeZipcode:        '',
            //ADD ADDRESS
            GetPresentAddress:  '',
            presentAddress:     '',
            presentProvince:    '',
            presentCity:        '',
            presentBarangay:    '',
            presentZipcode:     '',

            //SPOUSE INFORMATION
            SpouseFirstname:'',
            SpouseMiddlename:'',
            SpouseLastname:'',

            SpouseBirthdate:'',
            SpouseBirthplace:'',
            SpouseDateofMarriage:'',
            SpousePlaceofMarriage:'',

            SpouseContactNo:'',
            SpouseAddress:'',
            SpouseOccupation:'',

            SpouseEmployer:'',
            SpouseEmployerContact:'',
            SpouseEmployerBussinessAddress:'',

            //END SPOUSE INFORMATION
            GetParentsInfo:'',

            FAfirstname:'',
            FAmiddlename:'',
            FAlastname:'',
            FAcontactno:'',
            FAbirthdate:'',


            employeeaccount:'',
            username:'',
            password:'',



            url:"https://ritm.gov.ph/wp-content/uploads/2021/11/blank-profile-picture.png",

            Employee:[
                {
                    title:'Personal Info',
                    Buttonname:'Button1'
                },
                {
                    title:'Employment Info',
                    Buttonname:'Button2'
                },
                {
                    title:'Contact Info',
                    Buttonname:'Button3'
                },
                {
                    title:'Spouse Info',
                    Buttonname:'Button4'
                },      
                {
                    title:'Parents Info',
                    Buttonname:'Button5'
                },
                {   
                    title:'Dependent Info',
                    Buttonname:'Button6'
                },
                {   
                    title:'Account Info',
                    Buttonname:'Button7'
                }
            ],
    }
},
props: {
    Data: {
        type: Object,
        default: null,
    },
    fpk: {
        type: String,
        default: null,
    },
},
mounted(){
    
    this.emp_key = this.fpk
    this.getAllDivision()
    this.getPosition()
    this.GetPersonalInformation()
    this.getDisplaypicture()

  
   
   
},
computed:{

},
methods:{
    formatTinNumber() {
        let value = this.tin.replace(/\D/g, '');

        if (value.length <= 3) {
            this.tin = value;
        }
        else if (value.length <= 6) {
            this.tin = value.slice(0, 3) + '-' + value.slice(3)
        }
        else{
            this.tin = value.slice(0, 3) + '-' + value.slice(3, 6) + '-' + value.slice(6, 9);
        }
    },

    formatSssNumber() {
        let value = this.sss.replace(/\D/g, '');
        
        if (value.length <= 2) {
            this.sss = value;
        }
        else if (value.length <= 9) {
            this.sss = value.slice(0, 2) + '-' + value.slice(2, 9)
        }
        else{
            this.sss = value.slice(0, 2) + '-' + value.slice(2, 9) + '-' + value.slice(9,10);
        }
    },
    fortmatPhilhealth() {
        let value = this.philhealth.replace(/\D/g, '');
        
        if (value.length <= 2) {
            this.philhealth = value;
        }
        else if (value.length <= 1) {
            this.philhealth = value.slice(0, 2) + '-' + value.slice(2, 11)
        }
        else{
            this.philhealth = value.slice(0, 2) + '-' + value.slice(2, 11) + '-' + value.slice(11,12);
        }
    },
    formatPagibigNumber(){
        let value = this.pagibig.replace(/\D/g, '');
        this.pagibig = value.slice(0, 12)
    },
    formatMobileNumber(){
        let value = this.pagibig.replace(/\D/g, '');
        this.pagibig = value.slice(0, 12)
    },
    validateEmail() {
          // Basic email validation regex
          const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

          if (!this.email) {
            this.emailError = ''; // Clear error if email is empty
          } else if (!emailRegex.test(this.email)) {
            this.emailError = 'Please enter a valid email address.';
          } else {
            this.emailError = ''; // Clear error if email is valid
          }
        },
    refresh(){
        this.GetPersonalInformation()
    },
    showLoader(){
        this.loading = true
    },
    hideLoader(){
        this.loading = true
    },
    mobileVerification(){
        this.mobileNumber = "+" + this.mobileNumber.replace(/\D/g, '');
        if (this.mobileNumber.length < 4) {
            this.mobileNumber = "+639";
        }
    },
    emergencymobileVerification(){
        this.emergengcyContactNumber = "+" + this.emergengcyContactNumber.replace(/\D/g, '');
        if (this.emergengcyContactNumber.length < 4) {
            this.emergengcyContactNumber = "+639";
        }
    },
    Showpass(){
            if(this.ShowPassword == 'password'){
                this.ShowPassword = 'text'
            }
            else{
                this.ShowPassword = 'password'
            }
    },
    async getAllDivision(){
            const success      =  await Services.getDivision()
            this.division      =  success.data
    },
    // async getPosition(){
    //         const success      =  await Services.getPositionkey()
    //         this.position      =  success.data
    // },
    async changeDepartment(){
            this.SectionData   =  ''
            this.departmentID  =  ''
            this.Section       =  ''
            const success      =  await Services.getDepartmentbyDiv(this.divisionData)
            this.Department    =  success.data
            this.getpos()
    },
    async changeSection(){
        if(this.departmentID != ''){
            const success    =  await Services.getPositionbyID(this.departmentID)
            this.Section     =  success.data
        }
        else{
            this.Section     =  ''
        }
        this.SectionData     =  '' 
        this.getpos()
    },
    async getPosition(){
        const success        =  await Services.getPositionkey()
        this.Position        =  success.data
    },
    async getpos(){

        if(this.divisionData == ''){
            var divisionData = null
        }
        else{
            divisionData = this.divisionData
        }

        if(this.departmentID == ''){
            var departmentID = null
        }
        else{
            departmentID  = this.departmentID
        }

        if(this.SectionData == ''){
            var SectionData = null
        }
        else{
            SectionData  = this.SectionData
        }
        
        this.filterPosition  = this.Position.filter(position=>position.div_key == divisionData && position.dep_key == departmentID && position.sec_key == SectionData)
        
        if(!this.filterPosition){
            this.PositionData = ''
        }
    },
    async UpdatePersonalInformation() {

        //VALIDATION
        const header1 = "Please verify that all required information is provided."

        if(this.fname == null || this.fname == ""){
            const header = "FIRST NAME FIELD IS EMPTY"
            this.$emit("displayPrompt",header,header1)
            return
        }

        if(this.lname == null || this.lname == ""){
            const header = "LAST NAME FIELD IS EMPTY"
            this.$emit("displayPrompt",header,header1)
            return
        }

        if(this.bdate == null || this.bdate == ""){
            const header = "BIRTH DATE FIELD IS EMPTY"
            this.$emit("displayPrompt",header,header1)
            return
        }

        if(this.birthplace == null || this.birthplace == ""){
            const header = "BIRTH PLACE FIELD IS EMPTY"
            this.$emit("displayPrompt",header,header1)
            return
        }

        if(this.gender == null || this.gender == ""){
            const header = "GENDER FIELD IS EMPTY"
            this.$emit("displayPrompt",header,header1)
            return
        }

        
        if(this.civil == null || this.civil == ""){
            const header = "CIVIL STATUS FIELD IS EMPTY"
            this.$emit("displayPrompt",header,header1)
            return
        }

        if(this.nationality == null || this.nationality == ""){
            const header = "NATIONALITY FIELD IS EMPTY"
            this.$emit("displayPrompt",header,header1)
            return
        }

        if(this.religion == null || this.religion == ""){
            const header = "RELIGION FIELD IS EMPTY"
            this.$emit("displayPrompt",header,header1)
            return
        }

        
        if(this.sss == null || this.sss == ""){
            const header = "SSS FIELD IS EMPTY"
            this.$emit("displayPrompt",header,header1)
            return
        }

        if(this.philhealth == null || this.philhealth == ""){
            const header = "PHILHEALTH FIELD IS EMPTY"
            this.$emit("displayPrompt",header,header1)
            return
        }

        if(this.pagibig == null || this.pagibig == ""){
            const header = "PAGIBIG FIELD IS EMPTY"
            this.$emit("displayPrompt",header,header1)
            return
        }

        if(this.tin == null || this.tin == ""){
            const header = "TIN ID FIELD IS EMPTY"
            this.$emit("displayPrompt",header,header1)
            return
        }
        
        // if(this.landline == null || this.landline == ""){
        //     const header = "LANDLINE FIELD IS EMPTY"
        //     this.$emit("displayPrompt",header,header1)
        //     return
        // }

        if(this.email == null || this.email == ""){
            const header = "EMAIL FIELD IS EMPTY"
            this.$emit("displayPrompt",header,header1)
            return
        }

        if(this.email !=null){
            const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if(!emailPattern.test(this.email)){
                const header = "INVALID EMAIL FORMAT"
                this.$emit("displayPrompt",header,header1)
            }
        }

        if(this.mobileNumber == null || this.mobileNumber == ""){
            const header = "MOBILE NUMBER FIELD IS EMPTY"
            this.$emit("displayPrompt",header,header1)
            return
        }

        if(this.mobileNumber.length != 13){
            const header = "INVALID MOBILE NUMBER FORMAT"
            this.$emit("displayPrompt",header,header1)
            return
        }


        if(this.emergencyContactInformation == null || this.emergencyContactInformation == ""){
            const header = "EMERGENCY CONTACT FIELD IS EMPTY"
            this.$emit("displayPrompt",header,header1)
            return
        }

        if(this.relationship == null || this.relationship == ""){
            const header = "RELATIONSHIP CONTACT FIELD IS EMPTY"
            this.$emit("displayPrompt",header,header1)
            return
        }

        if(this.emergengcyContactNumber == null || this.emergengcyContactNumber == ""){
            const header = "EMERGENCY CONTACT NUMBER FIELD IS EMPTY"
            this.$emit("displayPrompt",header,header1)
            return
        }

        if(this.HomeAddress == null || this.HomeAddress == ""){
            const header = "HOME ADDRESS FIELD IS EMPTY"
            this.$emit("displayPrompt",header,header1)
            return
        }

        if(this.HomeProvince == null || this.HomeProvince == ""){
            const header = "HOME PROVINCE FIELD IS EMPTY"
            this.$emit("displayPrompt",header,header1)
            return
        }

        if(this.HomeCity == null || this.HomeCity == ""){
            const header = "HOME CITY FIELD IS EMPTY"
            this.$emit("displayPrompt",header,header1)
            return
        }

        if(this.HomeBarangay == null || this.HomeBarangay == ""){
            const header = "HOME CITY FIELD IS EMPTY"
            this.$emit("displayPrompt",header,header1)
            return
        }
        
        if(this.HomeZipcode == null || this.HomeZipcode == ""){
            const header = "HOME ZIP CODE FIELD IS EMPTY"
            this.$emit("displayPrompt",header,header1)
            return
        }

        if(this.presentAddress == null || this.presentAddress == ""){
            const header = "PRESENT ADDRESS FIELD IS EMPTY"
            this.$emit("displayPrompt",header,header1)
            return
        }

        if(this.presentProvince == null || this.presentProvince == ""){
            const header = "PRESENT PROVINCE FIELD IS EMPTY"
            this.$emit("displayPrompt",header,header1)
            return
        }

        if(this.presentCity == null || this.presentCity == ""){
            const header = "PRESENT CITY FIELD IS EMPTY"
            this.$emit("displayPrompt",header,header1)
            return
        }

        if(this.presentBarangay == null || this.presentBarangay == ""){
            const header = "PRESENT CITY FIELD IS EMPTY"
            this.$emit("displayPrompt",header,header1)
            return
        }
        
        if(this.presentZipcode == null || this.presentZipcode == ""){
            const header = "PRESENT ZIP CODE FIELD IS EMPTY"
            this.$emit("displayPrompt",header,header1)
            return
        }

        if(this.salaryGrade == null || this.salaryGrade == ""){
            const header = "SALARY GRADE FIELD IS EMPTY"
            this.$emit("displayPrompt",header,header1)
            return
        }

        if(this.employmentStatus == null || this.employmentStatus == ""){
            const header = "EMPLOYMENT STATUS GRADE FIELD IS EMPTY"
            this.$emit("displayPrompt",header,header1)
            return
        }
        
        if(this.dateHired == null || this.dateHired == ""){
            const header = "DATE HIRED FIELD IS EMPTY"
            this.$emit("displayPrompt",header,header1)
            return
        }

        if(this.PositionData == null || this.PositionData == ""){
            const header = "POSITION FIELD IS EMPTY"
            this.$emit("displayPrompt",header,header1)
            return
        }

        if(this.divisionData == null || this.divisionData == ""){
            const header = "DIVISION STATUS GRADE FIELD IS EMPTY"
            this.$emit("displayPrompt",header,header1)
            return
        }


        this.loading = true

        try{
            const success   =  await Services.UpdateEmployeeNameByid(
                            this.emp_key,
                            this.fname,
                            this.mname,
                            this.lname,
                            this.bdate,
                            this.birthplace,
                            this.gender,
                            this.civil,
                            this.nationality,
                            this.religion,
                            this.sss,
                            this.philhealth,
                            this.pagibig,
                            this.tin,
                            this.landline,
                            this.email,
                            this.emergencyContactInformation,
                            this.relationship,
                            this.emergengcyContactNumber,  
                            )
            this.response   =  success.data
        }
        catch{
            const header = "ERROR UPDATING EMPLOYEE INFORMATION"
            this.$emit("displayPrompt","ERROR!",header )
            this.loading = false
            return
        }
       
        
        try{
            const updateHomeAddress   =  await Services.updateAddress(
            this.emp_key,
            'H',
            this.HomeAddress,
            this.HomeProvince, 
            this.HomeCity,
            this.HomeBarangay,
            this.HomeZipcode,
        )
        this.response   =  updateHomeAddress.success
        }
        catch{
            const header = "ERROR UPDATING EMPLOYEE INFORMATION"
            this.$emit("displayPrompt","ERROR!",header )
            this.loading = false
            return
        }

        try{
            const presentHomeAddress   =  await Services.updateAddress(
            this.emp_key,
            'P',
            this.presentAddress,
            this.presentProvince, 
            this.presentCity,
            this.presentBarangay,
            this.presentZipcode,
        )
        this.response   =  presentHomeAddress.success
        }

        catch{
            const header = "ERROR UPDATING EMPLOYEE INFORMATION"
            this.$emit("displayPrompt","ERROR!",header )
            this.loading = false
            return
        }

       try{
        const updateSpouseInformation   =  await Services.updateSpouseInformation(
            this.emp_key,
            this.SpouseFirstname,
            this.SpouseLastname,
            this.SpouseMiddlename,
            this.SpouseBirthplace,
            this.SpouseBirthdate,
            this.SpouseDateofMarriage,
            this.SpousePlaceofMarriage,
            this.SpouseAddress,
            this.SpouseContactNo,
            this.SpouseOccupation,
            this.SpouseEmployer,
            this.SpouseEmployerContact,
            this.SpouseEmployerBussinessAddress,
        )
        this.response = updateSpouseInformation;

        const updateEmploymentInformation   =  await Services.updateEmploymentInformation(
            this.emp_key,
            this.salaryGrade,
            this.employmentStatus,
            this.dateHired,
            this.PositionData,
            this.divisionData,
            this.departmentID,
            this.SectionData
        )
        this.response = updateEmploymentInformation;


        await Services.updateParentsInformation(
            this.emp_key,
            'FA',
            this.FAfirstname,
            this.FAmiddlename,  
            this.FAlastname,   
            this.FAcontactno,  
            this.FAbirthdate,  
        )

        await Services.updateParentsInformation(
            this.emp_key,
            'MO',
            this.MOfirstname,
            this.MOmiddlename,  
            this.MOlastname,   
            this.MOcontactno,  
            this.MObirthdate,  
        )

        await Services.editEmployeeAccount(
            this.emp_key,
            this.username,
            this.password,  
        )
       }
       catch{
            const header = "ERROR UPDATING EMPLOYEE INFORMATION"
            this.$emit("displayPrompt","ERROR!",header )
            this.loading = false
            return
        }

      

        this.loading = false
        this.updatedInfo = true

    },
    async GetPersonalInformation(){

        this.loading = true
        
        const success          =  await Services.getEmployeeNameByid(this.emp_key)
        this.GetInfo           =  success.data.employeeinformation
        this.GetEmployment     =  success.data.employmentInformation[0]
        this.GetParentsFAInfo  =  success.data.parentsinfomartion.fa[0]
        this.GetParentsMOInfo  =  success.data.parentsinfomartion.mo[0]
        this.employeeaccount   =  success.data.employeeaccount[0]
        this.dependentInfo     =  success.data.dependent

            if(this.GetInfo.gender != null){
                this.gender        = this.GetInfo.gender
            }
            if(this.GetInfo.gender != null){
                this.civil                       = this.GetInfo.civil
            }
                this.fname                       = this.GetInfo.first_name,
                this.mname                       = this.GetInfo.femp_mname,
                this.lname                       = this.GetInfo.last_name,
                this.bdate                       = this.GetInfo.birthdate,
                this.birthplace                  = this.GetInfo.birthplace,   
                this.nationality                 = this.GetInfo.nationality,
                this.religion                    = this.GetInfo.religion,
                this.sss                         = this.GetInfo.sss,
                this.philhealth                  = this.GetInfo.philhealth,
                this.pagibig                     = this.GetInfo.pagibig,
                this.tin                         = this.GetInfo.tin,

                this.mobileNumber                = this.GetInfo.cp_no
                this.landline                    = this.GetInfo.landline
                this.email                       = this.GetInfo.email
                this.emergencyContactInformation = this.GetInfo.contact_name
                this.relationship                = this.GetInfo.contact_relation
                this.emergengcyContactNumber     = this.GetInfo.contact_cp_no

                //START EMPLOYMENT INFORMATION
                if(this.GetEmployment != null){
                    this.divisionData           = this.GetEmployment.division_code
                    this.changeDepartment()
                    this.departmentID           = this.GetEmployment.department_code
                    this.changeSection()
                    this.SectionData            = this.GetEmployment.section_code
                    this.PositionData           = this.GetEmployment.position_no
                    this.salaryGrade            = this.GetEmployment.salary_grade
                    this.employmentStatus       = this.GetEmployment.status
                    this.dateHired              = this.GetEmployment.hired_date

                }
                if( this.GetParentsFAInfo !=null){
                    this.FAfirstname   = this.GetParentsFAInfo.fname
                    this.FAmiddlename  = this.GetParentsFAInfo.mname
                    this.FAlastname    = this.GetParentsFAInfo.lname
                    this.FAcontactno   = this.GetParentsFAInfo.contact_no
                    this.FAbirthdate   = this.GetParentsFAInfo.birthdate
                }
            
                if( this.GetParentsMOInfo !=null){
                    this.MOfirstname   = this.GetParentsMOInfo.fname
                    this.MOmiddlename  = this.GetParentsMOInfo.mname
                    this.MOlastname    = this.GetParentsMOInfo.lname
                    this.MOcontactno   = this.GetParentsMOInfo.contact_no
                    this.MObirthdate   = this.GetParentsMOInfo.birthdate
                }
                if( this.employeeaccount !=null){
                    this.username   = this.employeeaccount.username
                    this.password   = this.employeeaccount.password
                }      
                 
    //END EMPLOYMENT INFORMATION

    const HomeAdd        =  await Services.getAddress(this.emp_key,'H')
    this.GetHomeAddres   =  HomeAdd.data    
        if(this.GetHomeAddres != null){
            this.HomeAddress   =    this.GetHomeAddres.address
            this.HomeProvince  =    this.GetHomeAddres.province
            this.HomeCity      =    this.GetHomeAddres.city
            this.HomeBarangay  =    this.GetHomeAddres.brgy
            this.HomeZipcode   =    this.GetHomeAddres.zip
        }

           
    const PresentAdd           =  await Services.getAddress(this.emp_key,'P')
    this.GetPresentAddress     =  PresentAdd.data
        if(this.GetPresentAddress != null){
            this.presentAddress  =    this.GetPresentAddress.address 
            this.presentProvince =    this.GetPresentAddress.province
            this.presentCity     =    this.GetPresentAddress.city
            this.presentBarangay =    this.GetPresentAddress.brgy
            this.presentZipcode  =    this.GetPresentAddress.zip
        }

    const Spouse             =  await Services.getSpouseInformation(this.emp_key)
    this.SpouseInformation   =  Spouse.data

        if(this.SpouseInformation != null){

            this.SpouseFirstname                = this.SpouseInformation.fname
            this.SpouseMiddlename               = this.SpouseInformation.middle_name
            this.SpouseLastname                 = this.SpouseInformation.lname

            this.SpouseBirthdate                = this.SpouseInformation.birthdate
            this.SpouseBirthplace               = this.SpouseInformation.birthplace
            this.SpouseDateofMarriage           = this.SpouseInformation.marriage_date
            this.SpousePlaceofMarriage          = this.SpouseInformation.marriage_place

            this.SpouseContactNo                = this.SpouseInformation.contact_no
            this.SpouseAddress                  = this.SpouseInformation.address
            this.SpouseOccupation               = this.SpouseInformation.occupation

            this.SpouseEmployer                 = this.SpouseInformation.employer_name
            this.SpouseEmployerContact          = this.SpouseInformation.employer_contact
            this.SpouseEmployerBussinessAddress = this.SpouseInformation.sp_employer_address
        }
        this.loading = false
    },
    async getDisplaypicture(){
           
      
            const success =  await Services.getDisplayPicture(this.emp_key)
            const test = success.success

            if(test == true){
                // this.url    = "data:image/png;base64,"+ success.data.data.image
                this.url = "data:image/png;base64,"+ success.data.image
            }
            else{
                this.url ="https://ritm.gov.ph/wp-content/uploads/2021/11/blank-profile-picture.png"
            }

        
            },

}

})

</script>

<style scoped>
table tr th{
    background-color: #006a00e1;
    padding: 11px 0px;
    position:sticky;
    top:0;
}
tr td{
    height: 20px;
    text-align: center;
    padding: 10px 1px;
    color: #11760ad8;
    border-bottom: 1px solid rgb(214, 214, 214);
    font-weight: 700;

}
.loader {
    width: 30px;
    height: 30px;
    border: 5px solid #ffffff;
    border-bottom-color: transparent;
    border-radius: 50%;

    box-sizing: border-box;
    animation: rotation 1s linear infinite;
    }

    @keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
    } 
</style>